var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.773 7.966h-3.772v-7.952h-20.001v7.952h-3.772c-1.229 0-2.229 1-2.229 2.229v13.559c0 1.23 1 2.229 2.228 2.229h3.772v6h20.001v-6h3.773c1.229 0 2.229-1 2.229-2.23v-13.559c0-1.229-1-2.229-2.229-2.229zM8 1.984h16.001v5.982h-16.001v-5.982zM24.001 29.985h-16.001v-11.012h16.001v11.012zM30.002 23.755c0 0.128-0.102 0.23-0.229 0.23h-3.773v-7.012h-20.001v7.012h-3.772c-0.126 0-0.229-0.102-0.229-0.23v-13.559c0-0.127 0.103-0.23 0.229-0.23h27.546c0.126 0 0.229 0.102 0.229 0.23zM26 11.982h-1c-0.552 0-1 0.448-1 1s0.448 1 1 1h1c0.552 0 1-0.448 1-1s-0.448-1-1-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.9f74c0f4a24132a8fb8edaaa770e1ecb.svg";
export { ForwardRef as ReactComponent };